import React, {Fragment} from 'react';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {observer} from 'mobx-react';

@observer
class DonateFormIhoDetails extends React.Component {
  handleBlur = (event) => {
    store.iho.sendToHonoreeLabel = event.target.value;
  };

  render() {
    const {
      amountHidden,
      fromFullName,
      honoreeFullName,
      message,
    } = store.iho.honoreeDraft;

    return (
      <Fragment>
        <div
          className='input-wrapper half-sized text-left'
        >
          <label htmlFor="fullName">{store.iho.isSpringIho ? 'Recipient' : t('views.donate_form.iho.details.honoree_full_name_label')}</label>
          <input
            name='honoreeFullName'
            onBlur={this.handleBlur}
            onChange={store.iho.updateHonoreeDraft}
            placeholder={store.iho.isSpringIho ? "Enter recipient's name" : t('views.donate_form.iho.details.honoree_full_name_placeholder')}
            required={true}
            type='text'
            value={honoreeFullName}
            {...(store.iho.honoreeDraft.type === 'print' && {maxLength: '100'})}
          />
        </div>
        <div
          className='input-wrapper half-sized text-left'
        >
          <label htmlFor="fromFullName">From</label>
          <input
            id='fromFullName'
            name='fromFullName'
            onChange={store.iho.updateHonoreeDraft}
            placeholder="Enter name"
            required={true}
            type='text'
            value={fromFullName}
            {...(store.iho.honoreeDraft.type === 'print' && {maxLength: '100'})}
          />
        </div>
        <div
          className='input-wrapper lh message'
        >
          <textarea
            name='message'
            onChange={store.iho.updateHonoreeDraft}
            placeholder={`Write a message (${store.iho.honoreeDraft.type === 'print' ? 'max 270 characters' : 'optional'})`}
            rows='5'
            value={message}
            {...(store.iho.honoreeDraft.type === 'print' && {maxLength: '270'})}
          />
        </div>

        {!store.iho.isSpringIho &&
          <div
            className='custom-check amount-hidden'
          >
            <input
              checked={amountHidden}
              id='amount-hidden'
              name='amountHidden'
              onChange={store.iho.updateHonoreeDraft}
              type='checkbox'
            />
            <label htmlFor='amount-hidden'>Hide the amount of my gift</label>
          </div>
        }
      </Fragment>
    );
  }
}

export default DonateFormIhoDetails;
